<template>
    <div class="scope-checkbox-container">
        <label class="scope-checkbox" :class="{ disabled: disabled }">
            <input
                v-model="model"
                @click="emit('change')"
                class="scope-checkbox__input"
                :disabled="disabled"
                :id="name"
                type="checkbox"
            />
            <svg
                class="scope-checkbox__check"
                width="16"
                height="16"
                viewBox="0 0 24 24"
            >
                <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            <span
                v-if="label && label.length"
                class="scope-checkbox-label"
                :class="{
                    crossed: withCrossLabel && model,
                    'border-bottom': withBorderBottom
                }"
            >
                {{ label }}
            </span>
        </label>
    </div>
</template>
<script setup>
import { defineModel, defineProps, watch } from 'vue';
const model = defineModel();

const emit = defineEmits(['change']);

defineProps({
    label: String,
    name: { type: String, default: () => Math.random().toString() },
    withCrossLabel: Boolean,
    withBorderBottom: Boolean,
    disabled: Boolean
});
</script>
<style lang="scss" scoped>
@import '../assets/styles/_main.scss';

.scope-checkbox {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &-container {
        display: flex;
        align-items: center;
        user-select: none;
    }

    &.disabled {
        cursor: not-allowed;
    }

    &-label {
        @include fz-14;
        font-weight: 500;
        color: $text-high-emphasis;
        margin-left: 8px;

        &.crossed {
            text-decoration: line-through;
        }

        &.border-bottom {
            border-bottom: 1px solid $border;
        }
    }
    &__input {
        width: 0;
        height: 0;
        opacity: 0;
        display: none;

        &:checked + .scope-checkbox__check {
            background-color: $primary-accent;
            border-color: $primary-accent;
            stroke-dashoffset: 0;
            stroke-opacity: 1;

            @include transition-default;
        }
        &:not(:checked) + .scope-checkbox__check {
            stroke-dashoffset: 20; // Animate back
            stroke-opacity: 0; // Fully hide after the animation
            @include transition-default;
        }
    }

    &__check {
        box-sizing: border-box;

        width: 16px;
        height: 16px;
        border: 1px solid var(--neutral-200);
        background: transparent;
        stroke: #f9f9f9;
        stroke-dasharray: 22;
        stroke-dashoffset: 20;
        stroke-linecap: round;
        stroke-opacity: 0;
        stroke-width: 2px;
        border-radius: 0.2rem;
        fill: none;
        @include transition-default;
    }

    &:not(.disabled):hover .scope-checkbox__input:not(:checked) + &__check {
        border-color: $icons-low-emphasis;
        background: transparent;
    }

    &:not(.disabled):hover .scope-checkbox__input:checked + &__check {
        background: $primary-soft;
        border-color: $primary-soft;
    }
}

body[theme='dark'] .scope-checkbox {
    .scope-checkbox__check {
        stroke: $color-white;
    }
}
</style>
